import { format } from 'sql-formatter';

export type SqlFormatMode = 'compact' | 'standard';

const MAJOR_KEYWORDS = [
  'SELECT', 'FROM', 'WHERE', 'INNER JOIN', 'LEFT JOIN', 'RIGHT JOIN', 'FULL JOIN',
  'CROSS JOIN', 'JOIN', 'ON', 'AND', 'OR', 'GROUP BY', 'HAVING', 'ORDER BY',
  'UNION', 'UPDATE', 'SET', 'DELETE', 'INSERT', 'VALUES',
];

/**
 * Formaterer T-SQL for visning/redigering.
 * - compact: nøkkelord (SELECT/FROM/WHERE/AND/...) på egne linjer, resten slått sammen
 * - standard: fullt innrykk fra sql-formatter
 * Returnerer input uendret hvis formatering feiler.
 */
export function formatSql(sql: string, mode: SqlFormatMode = 'standard'): string {
  if (!sql) return sql;
  try {
    if (mode === 'compact') {
      const formatted = format(sql, {
        language: 'tsql',
        keywordCase: 'upper',
        tabWidth: 2,
        useTabs: false,
        denseOperators: true,
        linesBetweenQueries: 0,
      });

      const compactLines: string[] = [];
      let currentLine = '';

      formatted.split('\n').forEach(line => {
        const trimmed = line.trim();
        if (!trimmed) return;

        const upper = trimmed.toUpperCase();
        const startsWithKeyword = MAJOR_KEYWORDS.some(kw => upper.startsWith(kw + ' ') || upper === kw);

        if (startsWithKeyword && currentLine) {
          compactLines.push(currentLine.trim());
          currentLine = trimmed;
        } else if (startsWithKeyword) {
          currentLine = trimmed;
        } else {
          currentLine = currentLine ? currentLine + ' ' + trimmed : trimmed;
        }
      });

      if (currentLine) compactLines.push(currentLine.trim());
      return compactLines.join('\n');
    }

    return format(sql, {
      language: 'tsql',
      keywordCase: 'upper',
      tabWidth: 4,
      useTabs: false,
      linesBetweenQueries: 1,
    });
  } catch (err) {
    console.error('SQL formatting failed:', err);
    return sql;
  }
}
